const PrefferedList = ({ list, callback,staticText = null }) => {
  const clickEvent = (name,value,inverted) => {
   callback(prevState => ({...prevState, name:name,value:value,inverted:inverted }))
  };

  return (
    <div className="preffered-list">
      {staticText ?
      <div
        className="preffered-list__item"
        key={staticText.text}
        onClick={(e) => {
          clickEvent(staticText.text,"",true)
        }}
      >
        {staticText.text}
      </div> : null}
      {list.map((item, index) => {
        return (
          <div
            className="preffered-list__item"
            key={item.name + index}
            onClick={(e) => {
              clickEvent(item.name,item.name,false);
            }}
          >
            {item.name}
          </div>
        );
      })}
    </div>
  );
};
export default PrefferedList;
